import type {PointedAtEntity, RequestConfig} from '@Components/ai-chat-window/ai-chat-window.types';

/** The request config of the message the user sends, plus the card they clicked before writing it, when they clicked one. */
export const withPointedAtEntity = (requestConfig: RequestConfig | undefined, pointedAtEntity: PointedAtEntity | null): RequestConfig | undefined => {
  if (pointedAtEntity === null) {
    return requestConfig;
  }

  return {...requestConfig, pointedAt: pointedAtEntity};
};
